import { ChangeSetViewModel } from "../../api/api";
import ChangeSetDialog from "./ChangeSetDialog";

type EditChangeSetDialogProps = {
	open: boolean;
	setOpen: (open: boolean) => void;
	changeSet: ChangeSetViewModel;
	onSuccess?: () => void;
};

export default function EditChangeSetDialog({ open, setOpen, changeSet, onSuccess }: EditChangeSetDialogProps) {
	return <ChangeSetDialog open={open} setOpen={setOpen} onSuccess={onSuccess} mode="edit" changeSetToEdit={changeSet} />;
}
